module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-ties.3028eda1.png";